import React from 'react';
import { CalendarTodoLineIcon } from '@bizzabo/icons';

const SessionNotFound = () => (
    <div className="session-not-found">
        <CalendarTodoLineIcon />
        <h3>Session Unavailable</h3>
        <p>This session cannot be accessed at the moment.</p>
        <p>Please check with event organizer.</p>
    </div>
);

export default SessionNotFound;
